import { map, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { tryFind } from "../../../fable_modules/fable-library-js.4.19.0/Map.js";
import { Model } from "./Types.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";

export function init(_page, user, _lastModel) {
    return [new Model(defaultArg(map((u) => defaultArg(tryFind("BeratungsterminUrl", u.SessionData), ""), user), "")), Cmd_none()];
}

//# sourceMappingURL=State.fs.js.map
